import { render, staticRenderFns } from "./AddNewChoirStepOne.vue?vue&type=template&id=4fe00a8d&scoped=true&"
import script from "./AddNewChoirStepOne.vue?vue&type=script&lang=ts&"
export * from "./AddNewChoirStepOne.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe00a8d",
  null
  
)

export default component.exports